import TabbedNavigation from 'common/components/tabbed_navigation';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

function mapStateToProps(state, { params, router }) {
  const { subcategory, pageSlug, focusGroupId } = params;
  const urlBase = `/${subcategory}/${pageSlug}/focus-groups/${focusGroupId}/view/`;

  const tabs = {
    links: [
      {
        url: `${urlBase}results`,
        name: 'results',
      },
      {
        url: `${urlBase}participants`,
        name: 'participants',
      },
      {
        url: `${urlBase}settings`,
        name: 'settings',
      }
    ]
  };

  return {
    projectUrl: params.projectUrl || '',
    tabs,
    router,
  };
}

export default withRouter(connect(mapStateToProps, { push })(TabbedNavigation));



// WEBPACK FOOTER //
// ./focus_groups/containers/tabs.js